import React, {useEffect} from 'react';
import {Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        width: "100%",
        paddingHorizontal: 24,
        paddingTop: 24,
        paddingBottom: 35,
    },
    section: {
        flexGrow: 1,
    },
});

export default function PDFReport(props) {
    useEffect(()=>{
    },[]);
    return (
        <Document>
            <Page
                orientation="portrait"
                size="A4" style={styles.page}
            >
                <View style={styles.section}>
                    <Text>Hello World!</Text>
                </View>
                <View style={styles.section}>
                    <Text>We're inside a PDF!</Text>
                </View>
            </Page>
        </Document>
    );
}